export default  {
  bindings: {
    spadays: '<',
    treatments: '<',
    upgrades: '<'
  },
  controller: 'upgradesListController',
  template: require('../views/upgrades.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/upgrades.list.component.js